import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { promosSortingRequestAction } from '../../actions/sorting';
import { Sorting } from '../../components/Sorting';
import { selectIsCompilation, selectIsLoading } from '../../selectors/pagination';
import { selectCurrentSorting, selectSortingOptions } from '../../selectors/sorting';
import { ESortVariants } from '../../types/jsonQuery/sortType';
import { TThunkDispatch } from '../../types/redux/thunk';

export const SortingContainer: React.FC = () => {
  const sortingOptions = useSelector(selectSortingOptions);
  const currentOption = useSelector(selectCurrentSorting);
  const isLoading = useSelector(selectIsLoading);
  const isCompilation = useSelector(selectIsCompilation);
  const dispatch: TThunkDispatch = useDispatch();

  const changeSorting = React.useCallback(
    (option: { value: ESortVariants }) => {
      dispatch(promosSortingRequestAction(option.value));
    },
    [dispatch],
  );

  if (isCompilation || !sortingOptions.length) {
    return null;
  }

  return (
    <Sorting
      disabled={isLoading}
      onChange={changeSorting}
      selectedOption={currentOption}
      options={sortingOptions}
      placeholder="По умолчанию"
    />
  );
};
